import * as React from 'react';

import Collection16 from './Collection16';

export const collection16 = () => <Collection16 />;

export default {
    title: 'Icon|Fill|Collection16',
    component: Collection16,
    parameters: {
        notes: "`import Collection16 from 'box-ui-elements/es/icon/fill/Collection16';`",
    },
};
